//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-param-reassign */
import { mapActions, mapGetters } from 'vuex';
import ErrorDisplay from '../../../../common/ErrorDisplay.vue';
import Checkbox from '../../../../common/svg/Checkbox.vue';
import Logo from '../../../../common/svg/Logo.vue';

import RegistrationStepAccountModal from '../components/modals/RegistrationStepAccountModal.vue';
import RegistrationStepTermsAndConditionsModal from '../components/modals/RegistrationStepTermsAndConditionsModal.vue';
import RegistrationStepSurveyModal from '../components/modals/RegistrationStepSurveyModal';
import RegistrationStepCtaModal from '../components/modals/RegistrationStepCTAModal';

export default {
  name: 'RedbullOptin',
  components: {
    ErrorDisplay,
    Checkbox,
    Logo,
    RegistrationStepAccountModal,
    RegistrationStepTermsAndConditionsModal,
    RegistrationStepSurveyModal,
    RegistrationStepCtaModal,
  },

  created() {
    this.pageTitle = 'Landing Page';
    this.description = 'Description';
    this.instructionsTitle = '3 Steps to Join';
  },

  data() {
    return {
      pageTitle: '',
      pageState: '',
      description: '',
      instructionsTitle: '',
      eventId: '',
      loading: false,
      error: null,
      steps: [
        {
          ref: 'cta',
          message: 'Agree to receive 2 surveys',
          completed: false,
          component: 'registration-step-cta-modal',
          payload: {
            text: 'Participation in this research study requires the submission of 2 surveys. The first will be emailed to you upon completion of this registration. Your response must be submitted before you complete the Wings for Life World Run on May 9, 2021. The second survey will be emailed to you after the World Run event has ended, and must be submitted by May 16th, 2021. You will not be included in the study unless you submit both surveys.',
            button: 'I agree to receive 2 surveys via email',
          },
        },
        {
          ref: 'terms-and-conditions',
          message: 'Accept terms and conditions',
          completed: null,
          component: 'registration-step-terms-and-conditions-modal',
        },
        {
          ref: 'account',
          message: 'Link your GPS watch to PWR Lab',
          completed: null,
          component: 'registration-step-account-modal',
          payload: {
            title: 'Link',
            list: [
              'First item',
              'Second item',
            ],
          },
        },
      ],
    };
  },

  methods: {
    ...mapActions(['initialize', 'updatePayment']),

    async registerNow() {
      this.pageState = 'Opting in...';
      this.loading = true;
      this.error = null;
      try {
        await this.handleTeamMember();
        await this.handleSurvey();

        await this.initialize();

        if (this.isNewUser) {
          await this.$router.push({ name: 'setup' });
        } else {
          this.handleUpdatePayment();
          await this.$router.push({ name: 'dashboard' });
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async handleUpdatePayment() {
      await this.updatePayment({
        member_id: this.loggedInMember.memberId,
        coupon: this.couponCode,
      });
    },


    async handleTeamMember() {
      await this.$container.dao.addMemberToTeam(this.loggedInMember.memberId, this.teamId);
    },

    async handleSurvey() {
      const survey = this.steps.find(step => step.ref === 'survey');
      if (!survey) return;

      await this.$api.saveSurvey(survey.payload.answers, this.schemaId, this.loggedInMember.awsCognitoSub);
    },

    async handleRegisterUserWithEvent() {
      const { payload: { answers } } = this.steps.find(step => step.ref === 'survey');
      if (!answers) return;

      await this.$api.registerUserWithEvent({
        emailAddress: this.loggedInMember.emailAddress,
        firstName: answers.firstName,
        lastName: answers.lastName,
        gender: answers.data.gender === 'Male' ? 'M' : 'F',
        birthDate: answers.data.birthdate,
      }, this.eventId);
    },

    handleError(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
    },

    launch(from) {
      console.log(this.$refs[from][0]);
      this.$refs[from][0].launch();
    },
  },

  computed: {
    ...mapGetters(['user', 'loggedInMember']),
    areStepsCompleted() {
      return this.steps.some(step => step.completed === null);
    },

    isNewUser() {
      return this.steps.some(step => step.completed === 'new');
    },

    teamId() {
      return this.$route.meta.teamId;
    },

    couponCode() {
      return this.$route.meta.couponCode;
    },

    schemaId() {
      return this.$route.meta.schemaId;
    },
  },
};
